import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import '../Style/Dashboard.css';
import CreateAssignRole from "./CreateAssignRole";
import { FaEllipsisV } from "react-icons/fa";
import ChatAdmin from "./ChatAdmin";
import  NoticeCard from './NoticeCard'


const ChatPage = () => {
  
return (
  <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
    <Header />

    <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
      <Sidebar />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <SubHeader />

        <div className="container-fluid p-2" style={{ flex: 1, overflow: "hidden" }}>
          <div className="row h-100">

            <div className="col-md-4 h-100">
              <div
                style={{
                  ...containerStyle,
                  height: "100%",
                  overflowY: "auto"
                }}
              >
                <NoticeCard />
              </div>
            </div>
            <div className="col-md-8 d-flex flex-column h-100" style={{ padding: 0 }}>
              <ChatAdmin />
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
);
};

const buttonStyle = {
    backgroundColor: "#007bb5",
    color: "white",
    border: "none",
    padding: "10px 10px",
    margin: "6px 0",
    width: "130px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    
    
  };

  const containerStyle = {
    // background: '#bfebfe',
    padding: "10px",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    
  };


export default ChatPage;
